import { Component } from '@angular/core';

@Component({
  selector: 'sa-loading',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss'],
})
export class LoadingSpinnerComponent {}
